import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO_URL, waLink } from "@/lib/wa";

const links = [
  { href: "#mete", label: "Mete" },
  { href: "#pacchetti", label: "Pacchetti" },
  { href: "#perche", label: "Perché Noi" },
  { href: "#faq", label: "FAQ" },
  { href: "#contatti", label: "Contatti" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.2, 0.8, 0.2, 1] }}
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? "py-3 bg-ink/80 backdrop-blur-xl border-b border-white/5" : "py-5 bg-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Atlante Viaggi" className="h-10 w-10 object-contain" />
          <div className="leading-tight">
            <div className="font-serif text-lg text-white tracking-wide">Atlante <span className="gold-text">Viaggi</span></div>
            <div className="overline text-[10px] tracking-[0.3em] text-gold/80">SCOPRI · VIVI · RICORDA</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-white/70 hover:text-gold transition-colors relative group"
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 h-px w-0 bg-gold transition-all group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          data-testid="nav-cta-whatsapp"
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:inline-flex btn-gold rounded-full px-5 py-2.5 text-sm"
        >
          Prenota Ora ✈️
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-ink-panel/95 backdrop-blur-xl border-t border-white/5"
          >
            <div className="flex flex-col gap-1 px-6 py-6">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="py-3 text-base text-white/80 hover:text-gold border-b border-white/5"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 btn-gold rounded-full text-center py-3"
              >
                Prenota su WhatsApp
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
